import { api } from './client';

export interface SolutionIdea {
  id: string;
  session_id: string;
  problem_statement_id: string | null;
  name: string;
  description: string | null;
  business_model: string | null;
  transformation_statement: string | null;
  ctr: number | null;
  budget: number | null;
  focus: number;
  selected: number;
  created_at: string;
  updated_at: string;
}

export async function listSolutionIdeas(
  sessionId: string
): Promise<SolutionIdea[]> {
  return api.get(`/solution-ideas?session_id=${sessionId}`);
}

export async function getSolutionIdea(id: string): Promise<SolutionIdea> {
  return api.get(`/solution-ideas/${id}`);
}

export async function createSolutionIdea(data: {
  session_id: string;
  problem_statement_id?: string;
  name: string;
  description?: string;
  business_model?: string;
  transformation_statement?: string;
}): Promise<SolutionIdea> {
  return api.post('/solution-ideas', data);
}

export async function updateSolutionIdea(
  id: string,
  data: Partial<Pick<SolutionIdea, 'name' | 'description' | 'business_model' | 'transformation_statement' | 'focus' | 'selected'>>
): Promise<SolutionIdea> {
  return api.put(`/solution-ideas/${id}`, data);
}

export async function deleteSolutionIdea(id: string): Promise<void> {
  return api.delete(`/solution-ideas/${id}`);
}
